import { OtherToolsLeftNavModule } from './../../school-tools/other-tools/other-tools-left-nav/other-tools-left-nav.module';
import { OtherToolsLayoutComponent } from './other-tools-layout.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [OtherToolsLayoutComponent],
  imports: [CommonModule, RouterModule, OtherToolsLeftNavModule],
  exports: [OtherToolsLayoutComponent],
  providers: [],
  schemas: [],
})
export class OtherToolsLayoutModule {}
